import styled from 'styled-components';
import ShippingSelector from 'js/components/core/form/ShippingSelector';

export default styled(ShippingSelector)`
  margin-top: 2rem;
`;
